const generateUniqueKey = () => {
	return (
		crypto?.randomUUID?.() ||
		`${Date.now()}-${Math.random().toString(36).substr(2, 9)}`
	);
};

const skeletonJobs = Array.from({ length: 10 }, () => ({
	id: generateUniqueKey(),
	logo_url:
		'https://talents.studysmarter.de/app/themes/studysmarter-job/dist/assets/images/fallback-logo.svg',
	job_title: '',
	job_url: '#',
	company_name: '',
	posted_date: '',
	pin_lists: ['', '', null, ''],
	is_external_link: true,
	is_easy_apply: false,
}));

export default skeletonJobs;
